import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type InternalMessageByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;

export type InternalMessageByIdQuery = {
  __typename?: 'Query';
  internalMessageById?: {
    __typename?: 'InternalMessage';
    id: string;
    messageId?: string | null;
    messageType?: string | null;
    type: Types.MessageType;
    provider: string;
    rawStatus: string;
    fromEmail?: string | null;
    createAt: { __typename?: 'Date'; milliseconds: number };
    recipient: { __typename?: 'InternalRecipientInfo'; email?: string | null; phoneNumber?: string | null };
  } | null;
};

export const InternalMessageByIdDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'InternalMessageById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'internalMessageById' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'messageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'messageType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rawStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fromEmail' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useInternalMessageByIdQuery__
 *
 * To run a query within a React component, call `useInternalMessageByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalMessageByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalMessageByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInternalMessageByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InternalMessageByIdQuery, InternalMessageByIdQueryVariables>) {
  return ApolloReactHooks.useQuery<InternalMessageByIdQuery, InternalMessageByIdQueryVariables>(InternalMessageByIdDocument, baseOptions);
}
export function useInternalMessageByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InternalMessageByIdQuery, InternalMessageByIdQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<InternalMessageByIdQuery, InternalMessageByIdQueryVariables>(InternalMessageByIdDocument, baseOptions);
}
export type InternalMessageByIdQueryHookResult = ReturnType<typeof useInternalMessageByIdQuery>;
export type InternalMessageByIdLazyQueryHookResult = ReturnType<typeof useInternalMessageByIdLazyQuery>;
export type InternalMessageByIdQueryResult = Apollo.QueryResult<InternalMessageByIdQuery, InternalMessageByIdQueryVariables>;
